module.exports = __webpack_public_path__ + "media/images/ipay-0938338acaf84379c3aa041c42f46208.png";